import React, { Component } from "react";
import { connect } from "react-redux";
import { 
  Button, 
  withStyles, 
  Dialog, 
  DialogContent, 
  DialogTitle,
  IconButton,
  Tooltip,
  CircularProgress,
  MenuItem
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import clsx from "clsx";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { styles } from "./Help.css";
import {
  setQuery,
  search,
  getHelpData,
  filterSearch,
  setDrawerOpen,
} from "../redux/HelpActions";
import HelpContent from "./HelpContent";
import { helpViewType } from "./Const";
import { deepCopyFunction } from "../../../../util/CommonFunc";


class HelpWrap extends Component {
  currentConfig = {}

  
  constructor(props) {
    super();
    this.state = {
      drawerOpen: props.open || false,
      openPopup : false,
    };
  }

  componentDidMount(){
    const{getHelpData, config,
      help: { helpItems },
    } = this.props;

    getHelpData(config);
    if((Object.keys(helpItems).length === 0 && helpItems.constructor === Object) ||  helpItems[config.id]?.length === 0){
      getHelpData(config);
    }
  }

  componentWillUnmount(){
    this.handleClose();
  }

  handleOpen = () => {
    const{
      getHelpData, 
      config ,
      setDrawerOpen, 
      help: { allItems },
      } = this.props;
    
      if(allItems[config.id]?.length === 0){
        getHelpData(config);
      }
    this.currentConfig = deepCopyFunction(config);

    this.setState({
      open: true,
      openPopup: true,
    },()=>{
      if(config.type !== helpViewType.SINGLE) setDrawerOpen(true,config);
    });

  };

  handleClose = () => {
    const{
      setDrawerOpen, 
      config,
      getHelpData
      } = this.props;
    this.setState({ open: false },()=>{
      setDrawerOpen(false,null);
      getHelpData(config, '', '');
    });
  };

  closeHelpPopup = () => {
    this.setState({ 
      openPopup: false,
      open: false
    });
  };

  onHelpHover = (e) => {
    const{
      getHelpData, 
      config ,
      } = this.props;
      
    getHelpData(config);
  }

  render() {
    const {
      classes,
      id,
      help: { loadingContent,  helpItems,allItems },
      config,
      textLabel
    } = this.props;

    return (
      <>
      {config?.type === helpViewType.TOOLTIP ? 
        ( allItems[config.id]?.length > 0 && 
          <Tooltip title={
            <>
            {loadingContent[config.id] && !helpItems[config.id] &&  
              <CircularProgress className={classes.circularProgressIcon} />
            }
              {!loadingContent[config.id] && helpItems[config.id] &&               
              <div className={classes.TooltipContentWrap}>
                <HelpContent 
                  selectedHelp = {helpItems[config.id][helpItems[config.id].length -1]} 
                  {...this.props} 
                />
                </div>
                }
            </>
          }>
            <Button
              onMouseEnter={this.onHelpHover}
              className={"helpTooltip"}
              aria-label={"help"}
            >
              <HelpOutlineIcon/>
            </Button>
          </Tooltip>
        )
      : 
        // config?.id === helpType.ALL ?       
        //   <Button
        //     title="Help"
        //     onClick={this.handleOpen}
        //     // disabled={drawerOpen || helpItems[config.id]?.length === 0}
        //     className={classes.helpCommonButton, "helpAddMargin"}
        //   >
            
        //     <HelpOutlineIcon />
        //   </Button>
        // :
        // (config?.id !== helpType.ALL && allItems[config?.id]?.length > 0 &&         
        (allItems[config?.id]?.length > 0 &&         
          <>
            {textLabel ? 
              <MenuItem
                onClick={this.handleOpen}
                // disabled={drawerOpen} 
                
                id={`context-${id}`}
              >
                <HelpOutlineIcon className={textLabel ? classes.contextIcons : null}/> <span>{textLabel}</span>
              </MenuItem>
              :
                <Button
                  title="Help"
                  onClick={this.handleOpen}
                  // disabled={drawerOpen}
                  className={clsx(classes.helpCommonButton, "helpAddMargin")}
                  aria-label={"help"}
                 
                >
                  <HelpOutlineIcon />
                </Button>
            }
          </>
        )
      }
        {/* {config.type === helpViewType.MULTIPLE && 
          <Drawer
            variant="persistent"
            key="help"
            anchor="right"
            // open={this.state.open}
            open={drawerOpen}
            onClose={this.handleClose}
          >
            <HelpMain
              currentConfig = {this.currentConfig}
              {...this.props}
              open={this.state.open}
              onClose={this.handleClose}
            />
          </Drawer>
         }   */}

        {!loadingContent[config.id] && helpItems[config.id] && config.type === helpViewType.SINGLE && 
          <Dialog onClose={this.closeHelpPopup} aria-labelledby="customized-dialog-title" open={this.state.openPopup}>
            <DialogTitle id="customized-dialog-title" onClose={this.closeHelpPopup}>
            <span class="helpTitle"> {helpItems[config.id][0]?.title}</span>
              <IconButton aria-label="close" className={classes.closeButton} onClick={this.closeHelpPopup}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>

              <HelpContent 
                selectedHelp = {helpItems[config.id][0]} 
                {...this.props} 
              />
              
            </DialogContent>
          </Dialog>
        }
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  help: state.help,
});

export default connect(mapStateToProps, {
  setQuery,
  search,
  getHelpData,
  filterSearch,
  setDrawerOpen,
})(
  withStyles(styles)(HelpWrap)
);
